import React, { useState, useEffect, useRef, useCallback, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Box, Grid, Paper, Skeleton } from '@mui/material'
import _ from "lodash"
import { getViewInstance } from "../actions/viewinstance";
import Header from "./layouts/Header";
import Loading from "./Loading";
import DynamicComponent from "./partials/DynamicComponent";
import ReactToPrint, { useReactToPrint } from "react-to-print";

import '../styles/print.css'
import ResponsiveRectangle from "./partials/skeletons/ResponsiveRectangle";
import Footer from "./layouts/Footer";

import { fetchViewInstances, selectViewInstanceById } from "../reducers/reuseable_vi";

 

const PhysicianSummary = (props) => {
    const { user: currentUser } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [callVI, setCallVI] = useState(false)
    useEffect(() => {
        if (window !== undefined) {
            window.scrollTo(0, 0)
        }
    }, [])
    const [searchParams] = useSearchParams();
    //const { viewInstance, settings } = useSelector(state => state.viewinstance)
    const viewInstance = useSelector(state => selectViewInstanceById(state,'PhysicianSummary'))
    const settings = viewInstance?.settings || {}
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [PrintView, setPrintView] = useState(false);
    const componentRef = useRef(null);
    const onBeforeGetContentResolve = React.useRef(null);
    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);

    useEffect(() => { }, [PrintView])

    const handleAfterPrint = React.useCallback(() => {
        console.log("`onAfterPrint` called"); // tslint:disable-line no-console    
        setPrintView(false);

    }, []);

    const handleBeforePrint = React.useCallback(() => {
        console.log("`onBeforePrint` called"); // tslint:disable-line no-console
    }, []);

    const handleOnBeforeGetContent = React.useCallback(() => {
        console.log("`onBeforeGetContent` called"); // tslint:disable-line no-console
        setPrintView(true);
        return new Promise((resolve) => {
            onBeforeGetContentResolve.current = resolve;
            setTimeout(() => {
                setPrintView(true);
                resolve();
            }, 1000);
        });
    }, [setLoading, setPrintView]);

    const handleActualPrint = () => {
        //setPrintView(true)
        //handlePrint()
        window.print()
    }

    window.onbeforeprint = () => handleActualPrint()

    const handlePrint = useReactToPrint({ 
        content: reactToPrintContent,
        documentTitle: "Physicians Summary Report",
        onBeforeGetContent: handleOnBeforeGetContent,
        onBeforePrint: handleBeforePrint,
        onAfterPrint: handleAfterPrint,
        removeAfterPrint: true
    });


    useEffect(() => {
        //IF EMPTY VI OR NOT THE DESIRED VI AND THE VI HAS NOT BEEN CALLED YET
        setLoading(true)
        if ((!viewInstance || !viewInstance.ReportPersonalPage) && !callVI) {
            //SO IT'S NOT CALLED MULTIPLE TIMES
            setCallVI(true)
            //CALL THE ACTION THAT FETCHES THE SERVICE AND UPDATES THE STATE
            dispatch(fetchViewInstances({authToken: currentUser.AuthToken, VIGuid:searchParams.get("vi"), VIName:"PhysicianSummary"}))
            //dispatch(getViewInstance(searchParams.get("vi"), currentUser.AuthToken))
            setLoading(false)
        }
        //WINDOW.LOCATION PROVIDES EXTRA CONTEXT SO WHEN TEH URL UPDATES THE APP UPDATES
    }, [window.location.pathname])

    /**
     * View instance return
     * ReportViewInstance:{
     *  ReportPage:[
     *      ReportFrame:[
     *          {"Visible":"1/0","Order":"","ComponentType":""}
     *          , {"Visible":"1/0","Order":"","ComponentType":""}
     *          , {"Visible":"1/0","Order":"","ComponentType":""}
     *          , {"Visible":"1/0","Order":"","ComponentType":""} 
     *      ]
     *  ]
     * }
     */

    const OrderedSections =
        viewInstance
        && viewInstance.ReportViewInstance
        && viewInstance.ReportViewInstance.ReportPage
        && viewInstance.ReportViewInstance.ReportPage[0].ReportFrame
        && [...viewInstance.ReportViewInstance.ReportPage[0].ReportFrame].sort(function (a, b) { return parseInt(a.Order) - parseInt(b.Order) })



    return (
        <Box ref={componentRef} className="psprintcontainer">

            <Header printFunction={() => { handleActualPrint() }} />
            <Grid container direction="row" spacing={2} sx={{ marginTop: '150px', marginLeft: '-12px' }} alignItems="stretch" justifyContent="center">

                {/** The idea is simple, we will send each array to a single component that will dictate its format */}
                {/** Each array will have a ComponentType attribute. [{ComponentType},{ComponentType},{ComponentType}] */}
                {/** This component type will load a specific component*/}

                { viewInstance && viewInstance.status==='success' && viewInstance.ReportViewInstance
                    && OrderedSections ? (

                    OrderedSections.map((reportComponent, index) => {
                        return (

                            <DynamicComponent component={reportComponent} settings={settings} delay={index} key={index} />

                        )
                    })
                ) : (
                    [1, 2, 3, 4, 5].map(x => {
                        return (
                            <Grid item xs={12}>
                                <Paper elevation={1} >
                                    <Skeleton variant="rectangular" animation="wave" sx={{ paddingTop: "30%" }} height={0} />
                                </Paper>
                            </Grid>
                        )
                    })

                )
                }



            </Grid>
            <Footer />

        </Box>
    );



};

export default React.forwardRef(PhysicianSummary);